import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { NEW_GREY_02 } from '@modules/elemental-page/config/about-us-style-constants';

export const SidePromo: StyleRule = ({ theme }) => {
    return {
        display: 'none',
        [theme.screen.laptop]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            position: 'sticky',
            marginTop: '-100vh',
            marginLeft: 'auto',
            height: '100vh',
            minHeight: pxToRem(800),
            width: pxToRem(254),
            right: 0,
            top: 0,
            zIndex: theme.siteVariables.zIndexes.overlay,
            background: 'transparent',
            padding: pxArrayToRem([44, 24]),
        },
    };
};

export const Title: StyleRule = ({ theme }) => {
    return {
        ...theme.siteVariables.textStyles.Heading.Medium65,
        textTransform: 'uppercase',
        marginBottom: pxToRem(20),
    };
};

export const Subtitle: StyleRule = ({ theme }) => {
    return {
        textTransform: 'uppercase',
        lineHeight: theme.siteVariables.lineHeightDefault,
        marginBottom: pxToRem(20),
        paddingRight: pxToRem(12),
    };
};

export const Head: StyleRule = () => {
    return {
        display: 'flex',
        justifyContent: 'end',
        paddingRight: pxToRem(14),
        [`& p`]: {
            margin: pxArrayToRem([11, 16]),
        },
    };
};

export const Footer: StyleRule = () => {
    return {
        gridGap: pxToRem(2),
        margin: pxArrayToRem([44, 0]),
        [`& svg`]: {
            fill: NEW_GREY_02,
            height: pxToRem(30),
            width: pxToRem(30),
        },
    };
};

export const PromoImageContainer: StyleRule = () => {
    return {
        position: 'relative',
        width: pxToRem(166),
        height: pxToRem(177),
    };
};
